import { createMuiTheme } from 'material-ui/styles';
// const primaryColor = "#9c27b0";
// const warningColor = "#ff9800";
// const successColor = "#4caf50";
// const infoColor = "#00acc1";
// const roseColor = "#e91e63";

const theme = createMuiTheme({
  "direction": "ltr",
  "palette": {
    "common": {
      "black": "#000",
      "white": "#fff",
      "transparent": "rgba(0, 0, 0, 0)",
      "fullBlack": "rgba(0, 0, 0, 1)",
      "darkBlack": "rgba(0, 0, 0, 0.87)",
      "lightBlack": "rgba(0, 0, 0, 0.54)",
      "minBlack": "rgba(0, 0, 0, 0.26)",
      "faintBlack": "rgba(0, 0, 0, 0.12)",
      "fullWhite": "rgba(255, 255, 255, 1)",
      "darkWhite": "rgba(255, 255, 255, 0.87)",
      "lightWhite": "rgba(255, 255, 255, 0.54)",
    },
    "type": "light",
    "primary": {
      "50": "#f6ebf7",
      "100": "#ec4e9",
      "200": "#d29dcb",
      "300": "#c075cc",
      "400": "#ae4ebe",
      "500": '#9c27b0',
      "600": "#8e24a0",
      "700": "#802091",
      "800": "#721d81",
      "900": "#641971",
      "A100": "#82b1ff",
      "A200": "#448aff",
      "A400": "#2979ff",
      "A700": "#2962ff",
      "contrastDefaultColor": "light"
    },
    "secondary": {
      "50": "#fce4ec",
      "100": "#f8bbd0",
      "200": "#f48fb1",
      "300": "#f06292",
      "400": "#ec407a",
      "500": "#e91e63",
      "600": "#d81b60",
      "700": "#c2185b",
      "800": "#ad1457",
      "900": "#880e4f",
      "A100": "#ff80ab",
      "A200": "#ff4081",
      "A400": "#f50057",
      "A700": "#c51162",
      "contrastDefaultColor": "light"
    },
    "error": {
      "50": "#ffebee",
      "100": "#ffcdd2",
      "200": "#ef9a9a",
      "300": "#e57373",
      "400": "#ef5350",
      "500": "#f44336",
      "600": "#e53935",
      "700": "#d32f2f",
      "800": "#c62828",
      "900": "#b71c1c",
      "A100": "#ff8a80",
      "A200": "#ff5252",
      "A400": "#ff1744",
      "A700": "#d50000",
      "contrastDefaultColor": "light"
    },
    "grey": {
      "50": "#fafafa",
      "100": "#f5f5f5",
      "200": "#eeeeee",
      "300": "#e0e0e0",
      "400": "#bdbdbd",
      "500": "#9e9e9e",
      "600": "#757575",
      "700": "#616161",
      "800": "#424242",
      "900": "#212121",
      "A100": "#d5d5d5",
      "A200": "#aaaaaa",
      "A400": "#303030",
      "A700": "#616161",
      "contrastDefaultColor": "dark"
    },
    "shades": {
      "dark": {
        "text": {
          "primary": "rgba(255, 255, 255, 1)",
          "secondary": "rgba(255, 255, 255, 0.7)",
          "disabled": "rgba(255, 255, 255, 0.5)",
          "hint": "rgba(255, 255, 255, 0.5)",
          "icon": "rgba(255, 255, 255, 0.5)",
          "divider": "rgba(255, 255, 255, 0.12)",
          "lightDivider": "rgba(255, 255, 255, 0.075)"
        },
        "input": {
          "bottomLine": "rgba(255, 255, 255, 0.7)",
          "helperText": "rgba(255, 255, 255, 0.7)",
          "labelText": "rgba(255, 255, 255, 0.7)",
          "inputText": "rgba(255, 255, 255, 1)",
          "disabled": "rgba(255, 255, 255, 0.5)"
        },
        "action": {
          "active": "rgba(255, 255, 255, 1)",
          "disabled": "rgba(255, 255, 255, 0.3)"
        },
        "background": {
          "default": "#303030",
          "paper": "#424242",
          "appBar": "#212121",
          "contentFrame": "#212121",
          "status": "#000"
        }
      },
      "light": {
        "text": {
          "primary": "rgba(0, 0, 0, 0.87)",
          "secondary": "rgba(0, 0, 0, 0.54)",
          "disabled": "rgba(0, 0, 0, 0.38)",
          "hint": "rgba(0, 0, 0, 0.38)",
          "icon": "rgba(0, 0, 0, 0.38)",
          "divider": "rgba(0, 0, 0, 0.12)",
          "lightDivider": "rgba(0, 0, 0, 0.075)"
        },
        "input": {
          "bottomLine": "rgba(0, 0, 0, 0.42)",
          "helperText": "rgba(0, 0, 0, 0.54)",
          "labelText": "rgba(0, 0, 0, 0.54)",
          "inputText": "rgba(0, 0, 0, 0.87)",
          "disabled": "rgba(0, 0, 0, 0.42)"
        },
        "action": {
          "active": "rgba(0, 0, 0, 0.54)",
          "disabled": "rgba(0, 0, 0, 0.26)"
        },
        "background": {
          "default": "#fafafa",
          "paper": "#fff",
          "appBar": "#f5f5f5",
          "contentFrame": "#eeeeee"
        }
      }
    },
    "text": {
      "primary": "rgba(0, 0, 0, 0.87)",
      "secondary": "rgba(0, 0, 0, 0.54)",
      "disabled": "rgba(0, 0, 0, 0.38)",
      "hint": "rgba(0, 0, 0, 0.38)",
      "icon": "rgba(0, 0, 0, 0.38)",
      "divider": "rgba(0, 0, 0, 0.12)",
      "lightDivider": "rgba(0, 0, 0, 0.075)"
    },
    "input": {
      "bottomLine": "rgba(0, 0, 0, 0.42)",
      "helperText": "rgba(0, 0, 0, 0.54)",
      "labelText": "rgba(0, 0, 0, 0.54)",
      "inputText": "rgba(0, 0, 0, 0.87)",
      "disabled": "rgba(0, 0, 0, 0.42)"
    },
    "action": {
      "active": "rgba(0, 0, 0, 0.54)",
      "disabled": "rgba(0, 0, 0, 0.26)"
    },
    "background": {
      "default": "#fafafa",
      "paper": "#fff",
      "appBar": "#f5f5f5",
      "contentFrame": "#eeeeee"
    }
  },
  "typography": {
    "fontFamily": "\"Roboto\", \"Helvetica\", \"Arial\", sans-serif",
    "fontSize": 14,
    "fontWeightLight": 300,
    "fontWeightRegular": 400,
    "fontWeightMedium": 500,
    "display4": {
      "fontSize": 112,
      "fontWeight": 300,
      "fontFamily": "\"Roboto\", \"Helvetica\", \"Arial\", sans-serif",
      "letterSpacing": "-.04em",
      "lineHeight": 1,
      "color": "rgba(0, 0, 0, 0.54)"
    },
    "display3": {
      "fontSize": 56,
      "fontWeight": 400,
      "fontFamily": "\"Roboto\", \"Helvetica\", \"Arial\", sans-serif",
      "letterSpacing": "-.02em",
      "lineHeight": 1.35,
      "color": "rgba(0, 0, 0, 0.54)"
    },
    "display2": {
      "fontSize": 45,
      "fontWeight": 400,
      "fontFamily": "\"Roboto\", \"Helvetica\", \"Arial\", sans-serif",
      "lineHeight": "48px",
      "color": "rgba(0, 0, 0, 0.54)"
    },
    "display1": {
      "fontSize": 34,
      "fontWeight": 400,
      "fontFamily": "\"Roboto\", \"Helvetica\", \"Arial\", sans-serif",
      "lineHeight": "40px",
      "color": "rgba(0, 0, 0, 0.54)"
    },
    "headline": {
      "fontSize": 24,
      "fontWeight": 400,
      "fontFamily": "\"Roboto\", \"Helvetica\", \"Arial\", sans-serif",
      "lineHeight": "32px",
      "color": "rgba(0, 0, 0, 0.87)"
    },
    "title": {
      "fontSize": 21,
      "fontWeight": 500,
      "fontFamily": "\"Roboto\", \"Helvetica\", \"Arial\", sans-serif",
      "lineHeight": 1,
      "color": "rgba(0, 0, 0, 0.87)"
    },
    "subheading": {
      "fontSize": 16,
      "fontWeight": 400,
      "fontFamily": "\"Roboto\", \"Helvetica\", \"Arial\", sans-serif",
      "lineHeight": "24px",
      "color": "rgba(0, 0, 0, 0.87)"
    },
    "body2": {
      "fontSize": 14,
      "fontWeight": 500,
      "fontFamily": "\"Roboto\", \"Helvetica\", \"Arial\", sans-serif",
      "lineHeight": "24px",
      "color": "rgba(0, 0, 0, 0.87)"
    },
    "body1": {
      "fontSize": 14,
      "fontWeight": 300,
      "fontFamily": "\"Roboto\", \"Helvetica\", \"Arial\", sans-serif",
      "lineHeight": "24px",
      "color": "rgba(0, 0, 0, 0.87)"
    },
    "caption": {
      "fontSize": 12,
      "fontWeight": 400,
      "fontFamily": "\"Roboto\", \"Helvetica\", \"Arial\", sans-serif",
      "lineHeight": 1,
      "color": "rgba(0, 0, 0, 0.54)"
    },
    "button": {
      "fontSize": 14,
      "textTransform": "uppercase",
      "fontWeight": 500,
      "fontFamily": "\"Roboto\", \"Helvetica\", \"Arial\", sans-serif"
    },
  },
  "shadows": [
    "none",
    "0px 1px 3px 0px rgba(0, 0, 0, 0.2),0px 1px 1px 0px rgba(0, 0, 0, 0.14),0px 2px 1px -1px rgba(0, 0, 0, 0.12)",
    "0px 1px 5px 0px rgba(0, 0, 0, 0.2),0px 2px 2px 0px rgba(0, 0, 0, 0.14),0px 3px 1px -2px rgba(0, 0, 0, 0.12)",
    "0px 1px 8px 0px rgba(0, 0, 0, 0.2),0px 3px 4px 0px rgba(0, 0, 0, 0.14),0px 3px 3px -2px rgba(0, 0, 0, 0.12)",
    "0px 2px 4px -1px rgba(0, 0, 0, 0.2),0px 4px 5px 0px rgba(0, 0, 0, 0.14),0px 1px 10px 0px rgba(0, 0, 0, 0.12)",
    "0px 3px 5px -1px rgba(0, 0, 0, 0.2),0px 5px 8px 0px rgba(0, 0, 0, 0.14),0px 1px 14px 0px rgba(0, 0, 0, 0.12)",
    "0px 3px 5px -1px rgba(0, 0, 0, 0.2),0px 6px 10px 0px rgba(0, 0, 0, 0.14),0px 1px 18px 0px rgba(0, 0, 0, 0.12)",
    "0px 4px 5px -2px rgba(0, 0, 0, 0.2),0px 7px 10px 1px rgba(0, 0, 0, 0.14),0px 2px 16px 1px rgba(0, 0, 0, 0.12)",
    "0px 5px 5px -3px rgba(0, 0, 0, 0.2),0px 8px 10px 1px rgba(0, 0, 0, 0.14),0px 3px 14px 2px rgba(0, 0, 0, 0.12)",
    "0px 5px 6px -3px rgba(0, 0, 0, 0.2),0px 9px 12px 1px rgba(0, 0, 0, 0.14),0px 3px 16px 2px rgba(0, 0, 0, 0.12)",
    "0px 6px 6px -3px rgba(0, 0, 0, 0.2),0px 10px 14px 1px rgba(0, 0, 0, 0.14),0px 4px 18px 3px rgba(0, 0, 0, 0.12)",
    "0px 6px 7px -4px rgba(0, 0, 0, 0.2),0px 11px 15px 1px rgba(0, 0, 0, 0.14),0px 4px 20px 3px rgba(0, 0, 0, 0.12)",
    "0px 7px 8px -4px rgba(0, 0, 0, 0.2),0px 12px 17px 2px rgba(0, 0, 0, 0.14),0px 5px 22px 4px rgba(0, 0, 0, 0.12)",
    "0px 7px 8px -4px rgba(0, 0, 0, 0.2),0px 13px 19px 2px rgba(0, 0, 0, 0.14),0px 5px 24px 4px rgba(0, 0, 0, 0.12)",
    "0px 7px 9px -4px rgba(0, 0, 0, 0.2),0px 14px 21px 2px rgba(0, 0, 0, 0.14),0px 5px 26px 4px rgba(0, 0, 0, 0.12)",
    "0px 8px 9px -5px rgba(0, 0, 0, 0.2),0px 15px 22px 2px rgba(0, 0, 0, 0.14),0px 6px 28px 5px rgba(0, 0, 0, 0.12)",
    "0px 8px 10px -5px rgba(0, 0, 0, 0.2),0px 16px 24px 2px rgba(0, 0, 0, 0.14),0px 6px 30px 5px rgba(0, 0, 0, 0.12)",
    "0px 8px 11px -5px rgba(0, 0, 0, 0.2),0px 17px 26px 2px rgba(0, 0, 0, 0.14),0px 6px 32px 5px rgba(0, 0, 0, 0.12)",
    "0px 9px 11px -5px rgba(0, 0, 0, 0.2),0px 18px 28px 2px rgba(0, 0, 0, 0.14),0px 7px 34px 6px rgba(0, 0, 0, 0.12)",
    "0px 9px 12px -6px rgba(0, 0, 0, 0.2),0px 19px 29px 2px rgba(0, 0, 0, 0.14),0px 7px 36px 6px rgba(0, 0, 0, 0.12)",
    "0px 10px 13px -6px rgba(0, 0, 0, 0.2),0px 20px 31px 3px rgba(0, 0, 0, 0.14),0px 8px 38px 7px rgba(0, 0, 0, 0.12)",
    "0px 10px 13px -6px rgba(0, 0, 0, 0.2),0px 21px 33px 3px rgba(0, 0, 0, 0.14),0px 8px 40px 7px rgba(0, 0, 0, 0.12)",
    "0px 10px 14px -6px rgba(0, 0, 0, 0.2),0px 22px 35px 3px rgba(0, 0, 0, 0.14),0px 8px 42px 7px rgba(0, 0, 0, 0.12)",
    "0px 11px 14px -7px rgba(0, 0, 0, 0.2),0px 23px 36px 3px rgba(0, 0, 0, 0.14),0px 9px 44px 8px rgba(0, 0, 0, 0.12)",
    "0px 11px 15px -7px rgba(0, 0, 0, 0.2),0px 24px 38px 3px rgba(0, 0, 0, 0.14),0px 9px 46px 8px rgba(0, 0, 0, 0.12)"
  ]
  //,"transitions": {
  //   "easing": {
  //     "easeInOut": "cubic-bezier(0.4, 0, 0.2, 1)",
  //     "easeOut": "cubic-bezier(0.0, 0, 0.2, 1)",
  //     "easeIn": "cubic-bezier(0.4, 0, 1, 1)",
  //     "sharp": "cubic-bezier(0.4, 0, 0.6, 1)"
  //   },
  //   "duration": {
  //     "shortest": 150,
  //     "shorter": 200,
  //     "short": 250,
  //     "standard": 300,
  //     "complex": 375,
  //     "enteringScreen": 225,
  //     "leavingScreen": 195
  //   }
  // }
  ,
  "mixins": {},
  "spacing": {
    "unit": 8
  },
  "breakpoints": {
    "keys": [
      "xs",
      "sm",
      "md",
      "lg",
      "xl"
    ],
    "values": [
      320,
      768,
      992,
      1140,
      1200
    ]
  },
  "zIndex": {
    "mobileStepper": 900,
    "menu": 1000,
    "appBar": 1100,
    "drawerOverlay": 1200,
    "navDrawer": 1300,
    "dialogOverlay": 1400,
    "dialog": 1500,
    "layer": 2000,
    "popover": 2100,
    "snackbar": 2900,
    "tooltip": 3000
  }
});

const drawerWidth = 240;
const styles = {
  footer: {
    background: theme.palette.grey[900]
  },
  paper: {
    width: '100%',
    marginTop: theme.spacing.unit * 3,
    overflowX: 'auto',
  },
  toolbar: {
    padding: 0
  },
  sub_toolbar: {
    background: theme.palette.grey[700]
  },
  tableToolbar:{
    padding:'0 15px',
    justifyContent: 'space-between',
    alignItems: 'flex-end'
  },
  heading: {
    flex:1
  },
  tableHead: {
    background: theme.palette.primary[700],
    color: 'white'
  },
  dialogMedia: {
    padding: 15
  },
  dialogColor: {
    padding: 15
  },
  colorPicker: {
    boxShadow: 'none!important',
    borderRadius: '0!important',
    padding: '0!important',
    width: 'auto!important'
  },
  button: {
    margin: theme.spacing.unit,
    width: 36,
    height:36
  },
  auto_toggle: {
    position:'absolute',
    margin: '20px auto',
    border: 'solid 1px ' + theme.palette.error[500],
    color: '#fff',
    opacity:0,
    top:0,
    left:0,
    right:0,
    width: '50%',
    background: '#fff',
    padding: '10px 15px',
    transform: 'translate3d(0,-200px,0)',
    // transition: 'all 0.3s linear',
    zIndex:1000,
    boxShadow: '0px 1px 5px 0px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 3px 1px -2px rgba(0, 0, 0, 0.12)'
  },
  run: {
    // transform: 'translate3d(0,0,0)',
    // opacity: 1
    animation: 'DownFade 4s ease-in 1s forwards'
  },
  right:{
      textAlign: 'right'
  },
  hide: {
    display: 'none!important'
  },
  error: {
    color: theme.palette.error[500],
    borderBottom: 'solid 2px '+ theme.palette.error[500]+'!important',
  },
  merncms_editor:{
    border: '1px solid rgba(0, 0, 0, 0.42)',
    boxShadow: '0 0 5px 0px #bbb inset',
    background: '#fff',
    paddingLeft: 15,
    paddingRight: 15,
    minHeight: 300
  },
  merncms_toolbar:{
    border: '1px solid rgba(0, 0, 0, 0.42)',
  },
  label_shrink: {
    transform: 'translate(0, 1.5px) scale(0.75)',
    transformOrigin: 'top left',
    display: 'block',
    marginTop: 20,
    marginBottom: 6
  },
  folder_view: {
    display: 'flex',
    flexWrap: 'wrap',
    margin: '0!important'
  },
  folder_view_li: {
    width: '25%',
    cursor: 'pointer'
  },
  folder_view_file_icon_wrapper:{
    display: 'flex',
  },
  folder_view_file_icon: {
    color: '#fff',
    width: 36,
    height: 36
  },
  container: {

  },
  form:{
    minWidth: 290,
    margin: '50px auto 0',
    padding:30,
    border: 'solid 1px #eee',
    boxShadow: '0 0 15px rgba(0,0,0,0.1)',
    background: '#fff'
  },
  formFlat:{
    minWidth: 290,
    margin: '0',
    padding:30,
    background: '#fff'
  },
  textField: {
    width: '100%',
  },
  textFieldInline:{
    width: '48%'
  },
  formRow: {
    justifyContent:'space-between',
    marginTop:16,
    marginBottom:8
  },
  formRowToolbar:{
    justifyContent:'space-between',
    marginTop:16,
    marginBottom:8,
    flex:1,
    paddingRight:15
  },
  formRowInline:{
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-end',
    paddingTop: 15,
  },
  formRowInlineTop:{
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
  },
  col1: {
    paddingRight: 15,
    flex: 1
  },
  col2: {
    paddingRight: 15,
    flex: 2
  },
  col3: {
    paddingRight: 15,
    flex: 3
  },
  col4: {
    paddingRight: 15,
    flex: 4
  },
  col5: {
    paddingRight: 15,
    flex: 5
  },
  col6: {
    paddingRight: 15,
    flex: 6
  },
  col7: {
    paddingRight: 15,
    flex: 7
  },
  col8: {
    paddingRight: 15,
    flex: 8
  },
  col9: {
    paddingRight: 15,
    flex: 9
  },
  col10: {
    paddingRight: 15,
    flex: 10
  },
  col11: {
    paddingRight: 15,
    flex: 11
  },
  cmd:{
    display: 'flex',
    justifyContent: 'center',
    padding: '15px'
  },
  label: {
    display:'inline-block',
    marginBottom:5,
    position:'relative',
    top:8
  },
  labelCell: {
    fontSize: '14px',
    color : 'rgba(0, 0, 0, 0.87)',
    fontWeight: 300
  },
  select: {
    borderRadius:0,
    appearance: 'listbox',
    border: 'none',
    borderBottom: 'solid 1px ' + theme.palette.input.bottomLine,
    padding: '9px 0',
    background:'none',
    outline: 'none',
    minHeight: 32,
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    fontSize: 16,
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    fontWeight: 300
  },
  selectOption: {
    fontSize: 16,
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    fontWeight: 300
  },
  suggestion: {
    borderBottom: 'solid 1px ' + theme.palette.input.bottomLine,
    marginTop:-theme.spacing.unit,
    boxShadow: theme.shadows[1]
  },
  chipRow:{
    display: 'flex',
    flexWrap: 'wrap',
    flexDirection:'row'
  },
  chip:{
    marginRight: theme.spacing.unit,
    marginBottom: theme.spacing.unit,
  },
  media:{
    height:200
  },
  thumbnail:{
    height: 60,
    width: 100,
    margin: '5px 0'
  },
  fluidThumbnail: {
    height: 60,
    marginRight: -15
  },
  fixedButton: {
    width: 120
  },
  paging:{
    background: '#fff'
  },
  appBar: {
    position: 'absolute',
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginLeft: -15,
  },
  flex:{
    flex:1
  },
  avatar: {
    width: 50,
    height: 50,
    borderRadius: '50%',
    overflow: 'hidden',
    margin: '10px auto'
  },
  loadingOverlay: {
    position: 'absolute',
    top:40,
    left:40,
    right:40,
    bottom:40,
    background: 'rgba(255,255,255,0.8)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 2
  },
  dialogProgress:{

  },
  progressUpload: {
    width: 250,
  },
  progressLoading: {
    margin: theme.spacing.unit * 2,
  },
  gridListTile: {
    border: 'solid 2px #fff',
    textAlign: 'center'
  },
  headingUsername: {
    color: '#fff',
    textDecoration: 'none'
  },
  [theme.breakpoints.up(1)]: {
    minForm: {
      width: '75%',
      maxWidth: 600
    },
  }
};

export {styles};
export default theme;
